<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm border-b border-n-slate-3">
    <button
      class="flex items-center select-none w-full bg-transparent m-0 cursor-grab justify-between py-3 px-4 hover:bg-n-slate-2 transition-colors duration-100 drag-handle"
      @click.stop="onToggle"
    >
      <div class="flex justify-between">
        <EmojiOrIcon class="inline-block w-5" :icon="icon" :emoji="emoji" />
        <h5
          class="text-n-slate-12 text-[13px] font-semibold mb-0 py-0 pr-2 pl-0"
        >
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center">
        <slot name="button" />
        <div class="flex justify-end text-n-slate-10">
          <span
            class="i-lucide-chevron-down size-4 transition-transform duration-200"
            :class="{ 'rotate-180': isOpen }"
          />
        </div>
      </div>
    </button>
    <div v-if="isOpen" :class="compact ? 'p-0' : 'px-4 pb-4'">
      <slot />
    </div>
  </div>
</template>
